'use strict';

var SystemStatusOverbookingTransformerFactory = function SystemStatusOverbookingTransformerFactory($rootScope, DataTransformer, momentService, UserProcessingTransformationService) {
  function SystemStatusOverbookingTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'system-status-overbooking-mode';
    this.priority = 1;
  }
  SystemStatusOverbookingTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusOverbookingTransformer.constructor = SystemStatusOverbookingTransformer;
  SystemStatusOverbookingTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SystemStatusOverbookingTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusOverbookingTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusOverbookingTransformer.prototype.transform = function (data) {
    var length = data && data.domain && data.domain.length || 0;
    for (var i = 0; i < length; i++) {
      var entry = data.domain[i];
      entry.isRowEditable = false;
      entry.isRowRemovable = false;
      entry.startDepartureDate = momentService.of(entry.startDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      entry.endDepartureDate = momentService.of(entry.endDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      entry.completionDate = momentService.of(entry.completionDate, momentService.FIELD.COMPLETED_DATE);
      entry.requestDate = momentService.of(entry.creationDate, momentService.FIELD.CREATED_DATE);
      if (entry.userName) {
        entry.userName = UserProcessingTransformationService.getUserDisplayName(entry.userName);
      }
      delete entry.creationDate;
    }
    return data.domain;
  };
  return SystemStatusOverbookingTransformer;
};
SystemStatusOverbookingTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = SystemStatusOverbookingTransformerFactory;